import React, { useState, useEffect } from "react";
import { API_BASE_URL } from "../config";
function Form({ historicalData, setHistoricalData }) {
  const [formData, setFormData] = useState({
    start_date: historicalData.start_date,
    end_date: historicalData.end_date,
    model: "lr_3",
    leverage: false,
    min_date: historicalData.min_date,
    max_date: historicalData.max_date,
  });

  const [models, setModels] = useState([]);

  useEffect(() => {
    // Update models list when historicalData changes
    setModels(historicalData.models_list);
  }, [historicalData.models_list]);

  useEffect(() => {
    // Fetch and update data whenever formData changes
    const fetchAndUpdateData = async () => {
      const filteredData = { ...formData };
      if (!formData.leverage) {
        delete filteredData.leverage;
      }

      const queryParams = new URLSearchParams(filteredData).toString();

      try {
        const response = await fetch(
          `${API_BASE_URL}/api/history/?${queryParams}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          },
        );
        const data = await response.json();
        setHistoricalData(data);
      } catch (error) {
        console.error("Error:", error);
      }
    };

    fetchAndUpdateData();
  }, [formData, setHistoricalData]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: type === "checkbox" ? !prevState[name] : value,
    }));
  };

  return (
    <form id="update-form" method="GET">
      <div className="form-input">
        <label htmlFor="start_date">Start Date:</label>
        <input
          type="date"
          id="start_date"
          name="start_date"
          value={formData.start_date}
          min={formData.min_date}
          max={formData.max_date}
          onChange={handleChange}
        />
      </div>
      <div className="form-input">
        <label htmlFor="end_date">End Date:</label>
        <input
          type="date"
          id="end_date"
          name="end_date"
          value={formData.end_date}
          min={formData.start_date}
          max={formData.max_date}
          onChange={handleChange}
        />
      </div>
      <div className="form-input">
        <label htmlFor="model">Model:</label>
        <select
          id="model"
          name="model"
          value={formData.model}
          onChange={handleChange}
        >
          {models.map((item) => (
            <option value={item} key={item} selected={item === formData.model}>
              {item.replace(/_/g, " ").toUpperCase()}
            </option>
          ))}
        </select>
      </div>
      <div className="form-input">
        <label htmlFor="leverage">Include Leverage:</label>
        <input
          type="checkbox"
          id="leverage"
          name="leverage"
          checked={formData.leverage}
          onChange={handleChange}
        />
      </div>
    </form>
  );
}

export default Form;
